module.exports = __webpack_public_path__ + "images/arrow-group-down.3a39dd7b79e5c9981ac6ecc81821fe4f.png";